// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {}

@media (max-width: 768px) {}

/* .................................................media 480px.......................................... */


@media (max-width: 480px) {

  .topspace {
    margin-top: 170px;
  }

  .search {
    display: block;
    width: 100%;
  }

  .socialHeader {
    display: block;
  }

  .socialIcon {

    justify-content: center;
  }

  .socialIcon1 {

    justify-content: left;
  }

  .mainmenu {
    padding: 10px !important;
  }

  .w-100 {
    width: 100% !important;
  }

  .bannerContent {
    position: absolute;
    z-index: 999;
    text-align: center;
    top: 197px;
    width: 100%;
    padding: 0 62px;
    left: auto;
  }



  .bannerContent p {
    text-align: center;
    width: auto;

  }

  .bannerContent h2 {
    font-size: 24px;
    line-height: 36px;
  }

  .bannerContent1 {
    position: absolute;
    z-index: 999;
    text-align: center;
    top: 148px;
    width: 100%;
    padding: 0 62px;
    left: auto;
  }



  .bannerContent1 h2 {
    font-size: 24px;
    line-height: 36px;
  }

  .bannerContent1 p {
    text-align: center;
    width: auto;

  }

  .copyRight {
    padding: 10px 42px;
  }



  .bannertitle {
    font-size: 14px;
    font-family: 'poppinsbold';
    color: #fff;
    position: absolute;
    width: 100%;
    /* top: 164px; */
  }

  .homeVideoYoutube {
    width: 100%;
    height: 259px;
  }

  .w100 {
    width: auto !important;
  }

  .media100 {
    width: 100% !important;
  }

  .ulList {
    column-count: auto;
  }

  .locationSelector {
    padding: 15px;
  }

  .mb0 {
    margin-bottom: 10px;
  }

  .ulList2 {
    column-count: auto;
  }

  .peginationBox a {
    padding: 3px 3px;
  }

  .flex {
    justify-content: center;
    margin: 5px 0;
  }

  .socialMediaSection {
    padding: 10px 0;
  }

  .mediaMB {
    margin-bottom: 15px;
  }

  .mediaMB20 {
    margin-bottom: 20px;
  }

  .mediaMB30 {
    margin-bottom: 30px;
  }

  .mediaMB40 {
    margin-bottom: 40px;
  }

  .feedbackCards {
    column-count: auto;
  }

  .mediaContentBox {
    padding: 40px 15px;
  }

  .nav-tabs .nav-link {
    margin-right: 20px;
  }

  .floatNone {
    float: none !important;
  }

  .mediaflex {
    justify-content: left;
  }

  .imgAdjt {
    float: none;
    margin-right: 0;
    margin-left: 0;
    margin-bottom: 20px;
  }

  .mediaimgAdjt {
    float: none;
    margin-right: 0;
    margin-left: 0;
    margin-bottom: 20px;
  }

  .searchWidth {
    width: 100%;
  }

  .wordBreak {
    word-break: break-all;
  }

  .bannertitleNew1 {
    padding: 59px 0;
  }



  .bannertitleNew {

    padding: 84px 0;

  }

  .mediabannertitleNew84 {

    padding: 84px 0;

  }

  .mediabannertitleNew {

    padding: 110px 0;

  }

  .mediabannertitleNew1 {
    padding: 59px 0;
  }

  .menuScroll {
    max-height: 200px;
    overflow: auto;
  }

  .mainmenuScroll {
    max-height: 410px;
    overflow: auto;
  }



  .mobileShow {
    display: block;
  }

  .mobileShowNone {
    display: none;
  }

  .textwithImg {
    float: none;
  }

  .tableWidth {
    width: 100%;
  }

  .tableProFac table {
    display: block;
    width: 100%;
    overflow-x: auto;
    height: auto !important;
    font-family: 'poppinsregular';

  }

  .videop {
    padding: 15px !important;
  }

  .formInline {
    display: block;
  }

  .formInline0 {
    margin-right: 0 !important;
  }

  .searchbtn {
    border-radius: 0 4px 4px 0 !important;
  }


  .doners .col-md-2 {
    flex: auto !important;
    max-width: max-content !important;
}

  .mbottom{
    margin-bottom: 20px;
  }


}



@media (max-width: 360px) {



  .navbar-brand {
    margin-right: 5rem !important;
  }


}`, "",{"version":3,"sources":["webpack://./src/assets/css/media-query.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B,2BAA2B;;AAE3B,2GAA2G;;;AAG3G;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;;IAEE,qBAAqB;EACvB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,eAAe;IACf,UAAU;EACZ;;;;EAIA;IACE,kBAAkB;IAClB,WAAW;;EAEb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,eAAe;IACf,UAAU;EACZ;;;;EAIA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;;EAEb;;EAEA;IACE,kBAAkB;EACpB;;;;EAIA;IACE,eAAe;IACf,0BAA0B;IAC1B,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;;;EAIA;;IAEE,eAAe;;EAEjB;;EAEA;;IAEE,eAAe;;EAEjB;;EAEA;;IAEE,gBAAgB;;EAElB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;;;EAIA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,6BAA6B;;EAE/B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,qCAAqC;EACvC;;;EAGA;IACE,qBAAqB;IACrB,iCAAiC;AACrC;;EAEE;IACE,mBAAmB;EACrB;;;AAGF;;;;AAIA;;;;EAIE;IACE,6BAA6B;EAC/B;;;AAGF","sourcesContent":["@media (max-width: 1024px) {}\n\n@media (max-width: 768px) {}\n\n/* .................................................media 480px.......................................... */\n\n\n@media (max-width: 480px) {\n\n  .topspace {\n    margin-top: 170px;\n  }\n\n  .search {\n    display: block;\n    width: 100%;\n  }\n\n  .socialHeader {\n    display: block;\n  }\n\n  .socialIcon {\n\n    justify-content: center;\n  }\n\n  .socialIcon1 {\n\n    justify-content: left;\n  }\n\n  .mainmenu {\n    padding: 10px !important;\n  }\n\n  .w-100 {\n    width: 100% !important;\n  }\n\n  .bannerContent {\n    position: absolute;\n    z-index: 999;\n    text-align: center;\n    top: 197px;\n    width: 100%;\n    padding: 0 62px;\n    left: auto;\n  }\n\n\n\n  .bannerContent p {\n    text-align: center;\n    width: auto;\n\n  }\n\n  .bannerContent h2 {\n    font-size: 24px;\n    line-height: 36px;\n  }\n\n  .bannerContent1 {\n    position: absolute;\n    z-index: 999;\n    text-align: center;\n    top: 148px;\n    width: 100%;\n    padding: 0 62px;\n    left: auto;\n  }\n\n\n\n  .bannerContent1 h2 {\n    font-size: 24px;\n    line-height: 36px;\n  }\n\n  .bannerContent1 p {\n    text-align: center;\n    width: auto;\n\n  }\n\n  .copyRight {\n    padding: 10px 42px;\n  }\n\n\n\n  .bannertitle {\n    font-size: 14px;\n    font-family: 'poppinsbold';\n    color: #fff;\n    position: absolute;\n    width: 100%;\n    /* top: 164px; */\n  }\n\n  .homeVideoYoutube {\n    width: 100%;\n    height: 259px;\n  }\n\n  .w100 {\n    width: auto !important;\n  }\n\n  .media100 {\n    width: 100% !important;\n  }\n\n  .ulList {\n    column-count: auto;\n  }\n\n  .locationSelector {\n    padding: 15px;\n  }\n\n  .mb0 {\n    margin-bottom: 10px;\n  }\n\n  .ulList2 {\n    column-count: auto;\n  }\n\n  .peginationBox a {\n    padding: 3px 3px;\n  }\n\n  .flex {\n    justify-content: center;\n    margin: 5px 0;\n  }\n\n  .socialMediaSection {\n    padding: 10px 0;\n  }\n\n  .mediaMB {\n    margin-bottom: 15px;\n  }\n\n  .mediaMB20 {\n    margin-bottom: 20px;\n  }\n\n  .mediaMB30 {\n    margin-bottom: 30px;\n  }\n\n  .mediaMB40 {\n    margin-bottom: 40px;\n  }\n\n  .feedbackCards {\n    column-count: auto;\n  }\n\n  .mediaContentBox {\n    padding: 40px 15px;\n  }\n\n  .nav-tabs .nav-link {\n    margin-right: 20px;\n  }\n\n  .floatNone {\n    float: none !important;\n  }\n\n  .mediaflex {\n    justify-content: left;\n  }\n\n  .imgAdjt {\n    float: none;\n    margin-right: 0;\n    margin-left: 0;\n    margin-bottom: 20px;\n  }\n\n  .mediaimgAdjt {\n    float: none;\n    margin-right: 0;\n    margin-left: 0;\n    margin-bottom: 20px;\n  }\n\n  .searchWidth {\n    width: 100%;\n  }\n\n  .wordBreak {\n    word-break: break-all;\n  }\n\n  .bannertitleNew1 {\n    padding: 59px 0;\n  }\n\n\n\n  .bannertitleNew {\n\n    padding: 84px 0;\n\n  }\n\n  .mediabannertitleNew84 {\n\n    padding: 84px 0;\n\n  }\n\n  .mediabannertitleNew {\n\n    padding: 110px 0;\n\n  }\n\n  .mediabannertitleNew1 {\n    padding: 59px 0;\n  }\n\n  .menuScroll {\n    max-height: 200px;\n    overflow: auto;\n  }\n\n  .mainmenuScroll {\n    max-height: 410px;\n    overflow: auto;\n  }\n\n\n\n  .mobileShow {\n    display: block;\n  }\n\n  .mobileShowNone {\n    display: none;\n  }\n\n  .textwithImg {\n    float: none;\n  }\n\n  .tableWidth {\n    width: 100%;\n  }\n\n  .tableProFac table {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    height: auto !important;\n    font-family: 'poppinsregular';\n\n  }\n\n  .videop {\n    padding: 15px !important;\n  }\n\n  .formInline {\n    display: block;\n  }\n\n  .formInline0 {\n    margin-right: 0 !important;\n  }\n\n  .searchbtn {\n    border-radius: 0 4px 4px 0 !important;\n  }\n\n\n  .doners .col-md-2 {\n    flex: auto !important;\n    max-width: max-content !important;\n}\n\n  .mbottom{\n    margin-bottom: 20px;\n  }\n\n\n}\n\n\n\n@media (max-width: 360px) {\n\n\n\n  .navbar-brand {\n    margin-right: 5rem !important;\n  }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
